import AppService from '@/api/AppService';
import productService from '@/api/productConfigService'
import packageService from '@/api/packageConfigService'
import featureService from '@/api/featureConfigService'
import { getField, updateField } from 'vuex-map-fields';
import { notifyApiError } from '@/utils/notification-helper';
import dashboardService from '@/api/dashboardService';
export const state = {
    settings: {},
    menuItem: [],
    products: [],
    packageData: [],
    features: [],
    tenants: [],
    clients: [],
    tenantRoles: [],
    sharedProfiles: [],
    years: [],
    activatedTenants: [],
    deActivatedTenants: []
};
export const getters = {
    getField,
    allProducts: state => state.products,
    allPackages: state => state.packageData,
    allFeatures: state => state.feature,
    allRoles: state => state.tenantRoles,
    getTenantDetailsOnYear: state => state.dashboard,
    getActivatedTenants: state => state.activatedTenants,
    getDeactivatedTenants: state => state.deActivatedTenants,
    getPackages: state => (productID) => state.packageData.filter((pack) => pack.productID == productID),
    getAddOns: state => state.features.filter(feature => feature.type == "Addon").map(addon => {
        return { ...addon, featureID: addon.id }
    }),
    getAddOnByID: state => (id) => state.features.map(addon => {
        return { ...addon, featureID: addon.id }
    }).find(feature => feature.type == "Addon" && feature.id == id),
    getVendors: state => state.vendors,
    getVendorByID: state => (id) => state.vendors.find(vendor => vendor.id == id),
    getYears: state => state.years
};
export const actions = {
    async loadSettings({ commit }) {
        const data = await fetch('/settings.json');
        const settings = await data.json()
        commit('setSettings', settings);
        return data;
    },
    async loadMenu({ commit }) {
        const { data } = await AppService.getMenu(); //TODO Get the menu items
        commit('setMenu', data.data);
    },
    async getProduct({ commit }) {//TODO merge all the initial data
        const response = await productService.getProducts();
        commit('getProducts', response.data)
    },
    async getPackage({ commit }) {
        const response = await packageService.getPackage();
        commit('getPackages', response.data.result)
    },
    async getFeature({ commit }) {
        const response = await featureService.getFeature();
        commit('getFeatures', response.data.result)
    },
    async getRoles({ commit }) {
        const response = await AppService.getRoles();
        commit('setRoles', response.data)
    },
    async getInitialData({ commit }) {
        AppService.getInitialData().then((result) => {
            commit('setInitialData', result)
        }).catch(notifyApiError);
    },
    async loadTenants({ commit }) {
        const { data } = await AppService.getTenants();
        commit('setTenants', data);
    },
    async loadClients({ commit }) {
        const { data } = await AppService.getClients();
        commit('setClients', data);
    },
    async getYear({ commit }) {//TODO merge all the initial data
        const response = await dashboardService.getYears();
        commit('getYears', response.data)
    },
};
export const mutations = {
    updateField,
    setMenu(state, item) {
        state.menuItem = item;
    },
    getProducts(state, product) {
        state.products = product
    },
    addProducts(state, product) {
        state.products.push(product);
    },
    updateProduct(state, product) {
        var products = state.products
        const index = products.map(item => item.id).indexOf(product.id)
        products.splice(index, 1)
        products.push(product);
    },
    removeProduct(state, product) {
        var products = state.products
        const index = products.map(item => item.code).indexOf(product.code)
        products.splice(index, 1)
    },
    getPackages(state, pack) {
        state.packageData = pack
    },
    getFeatures(state, feature) {
        state.features = feature
    },
    setRoles(state, role) {
        state.tenantRoles = role
    },
    setInitialData(state, initialData) {
        state.tenants = initialData[0].data;
        state.sharedProfiles = initialData[1].data;
        state.vendors = initialData[2].data;
        state.clients = initialData[3].data;
    },
    setTenants(state, tenants) {
        state.tenants = tenants
    },
    setClients(state, clients) {
        state.clients = clients
    },
    notify() { },
    setSettings(state, settings) {
        state.settings = settings;
    },
    getYears(state, years) {
        state.years = years;
    },
};

